import { useState } from 'react';

export const usePaginatedList = (initialCount = 5, increment = 3) => {
  const [displayedCount, setDisplayedCount] = useState(initialCount);

  const showMore = () => setDisplayedCount((prev) => prev + increment);

  return { displayedCount, showMore };
};
